import { ExternalLink, Link2 } from "lucide-react";

const WIDGET_URL = "https://bridgeit.theautonomy.ai/widget.html";

export function BridgePage() {
  return (
    <div className="relative min-h-[calc(100vh-4rem)]">
      {/* Background orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-60 -right-60 w-[800px] h-[800px] rounded-full bg-[#00D4FF]/[0.03] blur-[150px]" />
        <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] rounded-full bg-primary/[0.04] blur-[120px]" />
      </div>

      <div className="relative flex flex-col items-center justify-start pt-10 sm:pt-14 pb-20 px-4">
        {/* Page Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-[#00D4FF]/10 border border-[#00D4FF]/20 rounded-full px-4 py-1.5 text-sm text-[#00D4FF] font-medium mb-4">
            <Link2 className="w-3.5 h-3.5" />
            Cross-Chain Bridge
          </div>
          <h1 className="neon-text-orange font-display text-4xl sm:text-5xl font-bold mb-3 animate-neon-pulse">
            Bridge
          </h1>
          <p className="text-text-secondary text-base sm:text-lg max-w-lg mx-auto">
            Swap, bridge, and track pToken parity — all in one widget
          </p>
        </div>

        {/* BridgeIT Widget Embed */}
        <div className="w-full max-w-[480px]">
          <iframe
            src={WIDGET_URL}
            title="BridgeIT Widget"
            style={{
              width: "100%",
              height: "680px",
              border: "none",
              borderRadius: "16px",
              background: "transparent",
            }}
            allow="clipboard-write"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
          />
          <div className="mt-3 text-center">
            <a
              href="https://bridgeit.theautonomy.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs text-text-tertiary hover:text-[#00d4ff] transition-colors"
            >
              <ExternalLink className="w-3 h-3" />
              Open BridgeIT in full view
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
